import React, { useState } from 'react';
import { Button, Popover } from '@mui/material';
import { PopoverContent } from './ButtonPopover.styles';
var ButtonPopover = function (props) {
    var children = props.children, label = props.label;
    var _a = useState(null), popoverLoc = _a[0], setPopoverLoc = _a[1];
    var handleClick = function (evt) {
        var newPopoverLoc = popoverLoc ? null : evt.currentTarget;
        setPopoverLoc(newPopoverLoc);
    };
    var handleClose = function () {
        setPopoverLoc(null);
    };
    var open = Boolean(popoverLoc);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "contained", size: "small", onClick: handleClick }, label),
        React.createElement(Popover, { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, open: open, anchorEl: popoverLoc, onClose: handleClose },
            React.createElement(PopoverContent, null, children))));
};
export default ButtonPopover;
